var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20C4.5 20.2761 4.72386 20.5 5 20.5C5.27614 20.5 5.5 20.2761 5.5 20H4.5ZM5.35355 4.64645C5.15829 4.45118 4.84171 4.45118 4.64645 4.64645L1.46447 7.82843C1.2692 8.02369 1.2692 8.34027 1.46447 8.53553C1.65973 8.73079 1.97631 8.73079 2.17157 8.53553L5 5.70711L7.82843 8.53553C8.02369 8.73079 8.34027 8.73079 8.53553 8.53553C8.7308 8.34027 8.7308 8.02369 8.53553 7.82843L5.35355 4.64645ZM5.5 20L5.5 5H4.5L4.5 20H5.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20H14",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15L17 15",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10L20 10",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5L23 5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.fb5a0fd628e0499c1352013659cd6696.svg";
export { ForwardRef as ReactComponent };